(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-resenas"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ATRIBUTO = 'data-kvres-iniciado';

  function iniciarSeccion(seccion) {
    if (!seccion || seccion.hasAttribute(ATRIBUTO)) return;
    if (seccion.getAttribute('data-kvres-carrusel') !== 'true') return;

    var pista = seccion.querySelector('[data-kvres-pista]');
    var puntos = Array.prototype.slice.call(seccion.querySelectorAll('[data-kvres-punto]'));
    if (!pista || puntos.length === 0) return;

    seccion.setAttribute(ATRIBUTO, 'true');

    var tarjetas = Array.prototype.slice.call(pista.querySelectorAll('[data-kvres-tarjeta]'));
    var indiceActual = 0;
    var temporizador = null;
    var esperando = false;
    var autoplay = seccion.getAttribute('data-kvres-auto') === 'true';
    var velocidad = parseInt(seccion.getAttribute('data-kvres-velocidad'), 10) || 5000;

    function esMovil() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function pintarPuntos(indice) {
      for (var i = 0; i < puntos.length; i++) {
        if (i === indice) {
          puntos[i].classList.add('kvres-punto-activo');
        } else {
          puntos[i].classList.remove('kvres-punto-activo');
        }
      }
    }

    function calcularIndice() {
      var centro = pista.scrollLeft + pista.clientWidth / 2;
      var mejor = 0;
      var distanciaMinima = Infinity;
      for (var i = 0; i < tarjetas.length; i++) {
        var centroTarjeta = tarjetas[i].offsetLeft + tarjetas[i].offsetWidth / 2;
        var distancia = Math.abs(centroTarjeta - centro);
        if (distancia < distanciaMinima) {
          distanciaMinima = distancia;
          mejor = i;
        }
      }
      return mejor;
    }

    function irA(indice) {
      if (!tarjetas[indice]) return;
      indiceActual = indice;
      pista.scrollTo({
        left: tarjetas[indice].offsetLeft - pista.offsetLeft,
        behavior: 'smooth'
      });
      pintarPuntos(indice);
    }

    function detener() {
      if (temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    }

    function arrancar() {
      if (!autoplay || tarjetas.length < 2) return;
      detener();
      temporizador = setInterval(function () {
        if (!esMovil()) return;
        var siguiente = indiceActual + 1;
        if (siguiente >= tarjetas.length) siguiente = 0;
        irA(siguiente);
      }, velocidad);
    }

    pista.addEventListener('scroll', function () {
      if (esperando) return;
      esperando = true;
      window.requestAnimationFrame(function () {
        var indice = calcularIndice();
        if (indice !== indiceActual) {
          indiceActual = indice;
          pintarPuntos(indice);
        }
        esperando = false;
      });
    }, { passive: true });

    for (var i = 0; i < puntos.length; i++) {
      puntos[i].addEventListener('click', function (evento) {
        var destino = parseInt(evento.currentTarget.getAttribute('data-kvres-punto'), 10);
        irA(destino);
        detener();
        arrancar();
      });
    }

    pista.addEventListener('pointerdown', detener);
    pista.addEventListener('mouseenter', detener);
    pista.addEventListener('mouseleave', arrancar);

    window.addEventListener('resize', function () {
      if (!esMovil()) {
        detener();
      } else if (autoplay && !temporizador) {
        arrancar();
      }
    });

    pintarPuntos(0);
    arrancar();
  }

  function iniciarTodo(contexto) {
    var raiz = contexto || document;
    var secciones = raiz.querySelectorAll('[data-kvres-seccion]');
    for (var i = 0; i < secciones.length; i++) {
      iniciarSeccion(secciones[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodo(document);
    });
  } else {
    iniciarTodo(document);
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodo(evento.target);
  });

  document.addEventListener('shopify:block:select', function (evento) {
    var seccion = evento.target.closest('[data-kvres-seccion]');
    if (!seccion) return;
    var pista = seccion.querySelector('[data-kvres-pista]');
    if (!pista) return;
    pista.scrollTo({ left: evento.target.offsetLeft - pista.offsetLeft, behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-tabs-producto"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MARCA = 'data-kvtabs-iniciado';

  function iniciarSeccion(seccion) {
    if (!seccion || seccion.hasAttribute(MARCA)) return;
    seccion.setAttribute(MARCA, 'true');

    var pestanas = Array.prototype.slice.call(seccion.querySelectorAll('[data-kvtabs-pestana]'));
    var items = Array.prototype.slice.call(seccion.querySelectorAll('[data-kvtabs-item]'));
    var cabeceras = Array.prototype.slice.call(seccion.querySelectorAll('[data-kvtabs-cabecera]'));
    if (items.length === 0) return;

    var permitirMultiples = seccion.getAttribute('data-kvtabs-multiple') === 'true';
    var abrirPrimero = seccion.getAttribute('data-kvtabs-abrir-primero') === 'true';

    function activarPestana(indice) {
      for (var i = 0; i < items.length; i++) {
        if (i === indice) {
          items[i].classList.add('kvtabs-activo');
        } else {
          items[i].classList.remove('kvtabs-activo');
        }
      }
      for (var j = 0; j < pestanas.length; j++) {
        if (j === indice) {
          pestanas[j].classList.add('kvtabs-pestana-activa');
          pestanas[j].setAttribute('aria-selected', 'true');
        } else {
          pestanas[j].classList.remove('kvtabs-pestana-activa');
          pestanas[j].setAttribute('aria-selected', 'false');
        }
      }
    }

    function alternarAcordeon(indice) {
      var item = items[indice];
      if (!item) return;
      var estaAbierto = item.classList.contains('kvtabs-abierto');

      if (!permitirMultiples) {
        for (var i = 0; i < items.length; i++) {
          if (i !== indice) {
            items[i].classList.remove('kvtabs-abierto');
            if (cabeceras[i]) cabeceras[i].setAttribute('aria-expanded', 'false');
          }
        }
      }

      if (estaAbierto) {
        item.classList.remove('kvtabs-abierto');
        if (cabeceras[indice]) cabeceras[indice].setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('kvtabs-abierto');
        if (cabeceras[indice]) cabeceras[indice].setAttribute('aria-expanded', 'true');
      }
    }

    for (var p = 0; p < pestanas.length; p++) {
      pestanas[p].addEventListener('click', function (evento) {
        activarPestana(parseInt(evento.currentTarget.getAttribute('data-kvtabs-pestana'), 10));
      });
    }

    for (var c = 0; c < cabeceras.length; c++) {
      cabeceras[c].addEventListener('click', function (evento) {
        alternarAcordeon(parseInt(evento.currentTarget.getAttribute('data-kvtabs-cabecera'), 10));
      });
    }

    activarPestana(0);

    if (abrirPrimero && items[0]) {
      items[0].classList.add('kvtabs-abierto');
      if (cabeceras[0]) cabeceras[0].setAttribute('aria-expanded', 'true');
    }

    seccion.addEventListener('kvtabs:seleccionar', function (evento) {
      var indice = evento.detail.indice;
      activarPestana(indice);
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('kvtabs-abierto');
        if (cabeceras[i]) cabeceras[i].setAttribute('aria-expanded', 'false');
      }
      if (items[indice]) {
        items[indice].classList.add('kvtabs-abierto');
        if (cabeceras[indice]) cabeceras[indice].setAttribute('aria-expanded', 'true');
      }
    });
  }

  function iniciarTodo(contexto) {
    var raiz = contexto || document;
    var secciones = raiz.querySelectorAll('[data-kvtabs-seccion]');
    for (var i = 0; i < secciones.length; i++) {
      iniciarSeccion(secciones[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodo(document);
    });
  } else {
    iniciarTodo(document);
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodo(evento.target);
  });

  document.addEventListener('shopify:block:select', function (evento) {
    var item = evento.target.closest('[data-kvtabs-item]');
    if (!item) return;
    var seccion = item.closest('[data-kvtabs-seccion]');
    if (!seccion) return;
    var indice = parseInt(item.getAttribute('data-kvtabs-item'), 10);
    seccion.dispatchEvent(new CustomEvent('kvtabs:seleccionar', { detail: { indice: indice } }));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
